import { Sheet } from "./Sheet";
import { PAGES } from "../data/pages";
import { useSnak } from "../snak/SnakContext";
import { Pause, Play } from "lucide-react";

/** Table of contents: lets the HCP jump straight to any chapter. */
export function ChapterSheet({
  open,
  onClose
}: {
  open: boolean;
  onClose: () => void;
}) {
  const {
    page,
    go,
    playing,
    togglePlay
  } = useSnak();
  return <Sheet open={open} onClose={onClose} kicker="Contents" title="Go to any chapter" footer={<button onClick={() => {
    togglePlay();
    onClose();
  }} className="flex h-11 w-full items-center justify-center gap-2 rounded-full bg-ink text-[13px] font-semibold tracking-[0.08em] text-paper transition-colors duration-150 hover:bg-charcoal" data-id="element-22" data-mp="1g0rcnj7wvkgl">
          {playing ? <Pause className="h-4 w-4" strokeWidth={1.75} data-id="element-23" data-mp="36bm957jgz0fh" /> : <Play className="h-4 w-4" strokeWidth={1.75} data-id="element-24" data-mp="36ei6atnhtl2v" />}
          {playing ? "STOP GUIDED PLAYBACK" : page === PAGES.length - 1 ? "PLAY AS A GUIDED STORY FROM THE START" : "PLAY AS A GUIDED STORY"}
        </button>} data-id="element-21" data-mp="28r9dedl5x9qu">
      <ol className="-mt-1 border-t border-ink" data-id="element-25" data-mp="1q5j045tgupbf">
        {PAGES.map((p, i) => {
        const current = i === page;
        return <li key={p.id} className="border-b border-rule" data-id="element-26" data-mp="1v5nbxijfivvb" data-mpi={i}>
              <button onClick={() => {
            go(i);
            onClose();
          }} aria-current={current ? "page" : undefined} className="group grid w-full grid-cols-[2rem_1fr] items-baseline gap-2 py-3.5 text-left" data-id="element-27" data-mp="1z70enjr86iy0">
                <span className={`tabular text-[13px] ${current ? "font-semibold text-navy" : "text-muted"}`} data-id="element-28" data-mp="1bg3dn20yx61j">
                  {String(i + 1).padStart(2, "0")}
                </span>
                <span className="min-w-0" data-id="element-29" data-mp="jqi1fsd23t15">
                  <span className={`block font-serif text-[18px] leading-tight transition-colors duration-150 ${current ? "text-navy" : "text-ink group-hover:text-navy"}`} data-id="element-30" data-mp="jpq8yqerabf3">
                    {p.chapter}
                    {current && <span className="ml-2 align-middle font-sans text-[11px] font-medium text-navy" data-id="element-31" data-mp="1m34mdfuj6lsl">You are here</span>}
                  </span>
                  <span className="mt-0.5 block text-[12.5px] leading-snug text-muted" data-id="element-32" data-mp="1vso42i6ic9lv">{p.summary}</span>
                </span>
              </button>
            </li>;
      })}
      </ol>
    </Sheet>;
}